/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import queryString from "query-string";

import { CustomerAPIClient } from "../api_clients";
import { IAuthContext } from "../providers/CognitoAuthProvider";

import {
  getTransportationType,
  getTransportationTypeName,
} from "enums/transportationType";
import {
  SuggestedPreparedRoute,
  SuggestedPreparedRouteDetail,
} from "models/suggestedPreparedRoute";

export type CandidateRoutesMode = "car" | "walk" | "bicycle";

export interface GetCandidateRoutesParams {
  departure_address_id: number;
  arrival_address_id: number;
  mode?: CandidateRoutesMode;
  waypoint_address_id?: number;
}

export const getCandidateRoutes = async (
  auth: IAuthContext,
  params: GetCandidateRoutesParams
): Promise<SuggestedPreparedRoute[]> => {
  const qs = queryString.stringify(params);
  const result = await CustomerAPIClient.get(
    auth,
    `/api/candidate_routes?${qs}`
  );

  const suggestedPreparedRoutes: SuggestedPreparedRoute[] = [];

  for (const data of result) {
    const suggestedPreparedRouteDetails: SuggestedPreparedRouteDetail[] =
      data.reduce(
        (acc: SuggestedPreparedRouteDetail[], datum: any) => [
          ...acc,
          {
            arrivalId: datum.arrival_id,
            arrivalName: datum.arrival_name,
            departureId: datum.departure_id,
            departureName: datum.departure_name,
            distanceKm: datum.distance_km,
            fare: datum.fare,
            lineId: datum.line_id,
            lineName: datum.line_name,
            orderNo: datum.order,
            time: datum.time,
            transportationType: datum.transportation,
            transportationTypeName: getTransportationTypeName(
              getTransportationType(parseInt(datum.transportation, 10))!
            ),
            useCommuterPass: datum.use_commuter_pass,
            initialUseCommuterPass: datum.use_commuter_pass,
          } as SuggestedPreparedRouteDetail,
        ],
        []
      );

    const totalDistanceKm: number = suggestedPreparedRouteDetails.reduce(
      (acc: number, suggestedPreparedRouteDetail) =>
        acc + suggestedPreparedRouteDetail.distanceKm!,
      0
    );

    const totalFare: number = suggestedPreparedRouteDetails.reduce(
      (acc: number, suggestedPreparedRouteDetail) =>
        acc + suggestedPreparedRouteDetail.fare!,
      0
    );

    const totalTime: number = suggestedPreparedRouteDetails.reduce(
      (acc: number, suggestedPreparedRouteDetail) =>
        acc + suggestedPreparedRouteDetail.time!,
      0
    );

    suggestedPreparedRoutes.push({
      departureId: params.departure_address_id,
      departureName: "",
      arrivalId: params.arrival_address_id,
      arrivalName: "",
      suggestedPreparedRouteDetails,
      totalDistanceKm,
      totalFare,
      totalTime,
      type: "",
      typeName: "",
    } as SuggestedPreparedRoute);
  }

  return suggestedPreparedRoutes;
};
/* eslint-enable */
